import styled from 'styled-components';

export const LoginContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;

  background-color: #f9f9ff;
`;

export const LeftSideLogoContainer = styled.div`
  max-width: 48%;
  min-width: 43%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  background-color: #f58220;

  position: relative;

  div {
    max-width: 300px;
    min-width: 196px;
    height: fit-content;
    position: relative;

    img {
      object-fit: fill;
      max-width: 100%;
    }

    h1 {
      font-size: 5vh;
      text-align: left;
      color: white;
      font-weight: 800;
      white-space: nowrap;
      max-width: 100%;
    }
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const LogoContainerMobileScreen = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  padding: 36px 0px;

  justify-self: flex-start;

  position: absolute;
  top: 0;

  background-color: #f58220;

  img {
    object-fit: fill;
    max-width: 236px;
  }

  h1 {
    align-self: center !important;
    font-size: 3vh;
    text-align: center;
    color: white !important;
    font-weight: 800;
    white-space: nowrap;
    max-width: 100%;
  }

  @media (min-width: 1024px) {
    display: none;
  }
`;

export const RightSideFormLoginContainer = styled.div`
  flex: 1;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  h1 {
    font-size: 2.6vh;
    color: #005fae;
    white-space: nowrap;
    align-self: start;
  }

  h3 {
    font-size: 2vh;
    color: #005fae;
    align-self: start;
  }

  form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 36px;

    width: 80%;
    max-width: 456px;
    height: fit-content;

    span {
      font-size: 1.6vh;
      color: #807e90;
      align-self: flex-end;
      cursor: pointer;
      text-decoration: underline;
      font-weight: 300;

      :hover {
        transition: 0.1s;
        color: #005fae;
        font-weight: 600;
      }
    }

    button {
      width: 100%;
      font-size: 2vh;
    }

    @media (max-width: 1024px) {
      margin-top: 156px;
    }
  }
`;

export const LabelTop = styled.div`
  width: 100%;
  min-width: fit-content;
  position: relative;

  svg {
    position: absolute;
    right: 12px;
    top: 0;
    width: 24px;
    height: 100%;
  }

  input {
    border: 1px solid;
    font-size: 16px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.gray[500]};
    background-color: #dbe8f310;
  }

  p {
    position: absolute;
    top: -9px;
    left: 8px;
    color: #807e90;
    font-size: 12px;
    line-height: 18px;
    background-color: #f9f9ff;
    padding: 0 4px;
    z-index: 1;
  }
`;
